{
  "ClientConfiguration_Table_Headers_Description": "Description",
  "ClientConfiguration_Table_Headers_TelSys": "Serveur de téléphonie",
  "ClientConfiguration_Table_Headers_Partition": "Partition",
  "ClientConfiguration_Table_Headers_Device": "Appareil",
  "ClientConfiguration_Footer_Add": "Ajouter",
  "ClientConfiguration_Footer_View": "Voir",
  "ClientConfiguration_Footer_Change": "Changement",
  "ClientConfiguration_Footer_Delete": "Supprimer",
  "ClientConfiguration_Footer_Selected": "{} Sélectionné",
  "ClientConfiguration_Footer_NoRows": "Rien à voir ici...",
  "ClientConfiguration_No_Available_CMEs": "Vous n'avez pas de CME avec les capacités requises",
  "NAME": "ClientConfigurationLanguage",
  "ClientConfiguration_Table_Headers_CME": "Serveur de téléphonie",
  "ClientConfiguration_Admin_Filters_CME": "FMC",
  "ClientConfiguration_Admin_Filters_IncludeChildCMEs": "Inclure la formation médicale continue (FMC) pour les enfants",
  "ClientConfiguration_Admin_Filters_Search": "Recherche"
}